import"../../../../../../@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{html as l}from"../../../../../../lit-html@3.2.1/node_modules/lit-html/lit-html.js";import"../../../../../../lit-element@4.1.1/node_modules/lit-element/lit-element.js";import{Field as e}from"./field.js";/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */class a extends e{renderOutline(i){return l`
      <div class="outline">
        <div class="outline-start"></div>
        <div class="outline-notch">
          <div class="outline-panel-inactive"></div>
          <div class="outline-panel-active"></div>
          <div class="outline-label">${i}</div>
        </div>
        <div class="outline-end"></div>
      </div>
    `}}export{a as OutlinedField};
